// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (self) => {
	return {
		get baseAppParameterEndpoint() {
			return `/app-parameters`;
		}
	};
};
